/* global axios */

const get = (accountId, conversationId) =>
  axios.get(`/api/v2/accounts/${accountId}/ai_audits/${conversationId}`);

const create = (accountId, conversationId) =>
  axios.post(`/api/v2/accounts/${accountId}/ai_audits`, {
    conversation_id: conversationId,
  });

const reprocessAll = (accountId, params = {}) =>
  axios.post(`/api/v2/accounts/${accountId}/ai_audits/reprocess_all`, params);

const validate = (accountId, conversationId) =>
  axios.patch(`/api/v2/accounts/${accountId}/ai_audits/${conversationId}/validate`);

export default { get, create, reprocessAll, validate };
